import React from 'react'

import Slider from '@material-ui/core/Slider'
import { withStyles } from '@material-ui/core/styles'
import isFunction from 'lodash/isFunction'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import Upgrade from 'drawer/tabs/Upgrade'

import IconOpacity from './IconOpacity'
import { ICON_COLOR_DISABLED, ICON_COLOR_ENABLED, PANEL_TITLE_OPACITY } from './LayerPanels'

const styles = theme => ({
  root: {
    padding: 20
  },
  upgradeWrapper: {}
})

class LayerPanelOpacity extends React.Component {
  constructor (props) {
    super(props)
    const { titleid } = this.props
    const olLayer = PoziUtils.getOpenLayersObjectFromTitleID(titleid)
    let opacity = 100
    if (olLayer && isFunction(olLayer.getOpacity)) {
      opacity = olLayer.getOpacity() * 100
    }

    this.state = {
      value: opacity
    }
    this.pure = {}
    this.pure.handleChange = this.handleChange.bind(this)
    this.pure.upgradeText = 'Upgrade Pozi to enable dynamic layer opacity adjustment.'
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  handleChange (event, value) {
    const { titleid } = this.props
    this.setState({ value })
    const olLayer = PoziUtils.getOpenLayersObjectFromTitleID(titleid)
    if (!olLayer) {
      console.error('Unable to find layer from titleid', titleid)
      return
    }
    if (value > 100) {
      value = 100
    }
    value = value / 100

    // console.debug('_layerOpacityChanged: Set layer opacity', titleid, value, olLayer)

    olLayer.setOpacity(value)
  }

  render () {
    const { classes, titleid } = this.props
    const { value } = this.state

    const visible = Model.get('config.layout.drawer.tabs.layers.opacity.visible', true)
    if (!visible) {
      return null
    }

    let icon = ''
    let markup = ''

    const licensed = Model.get('config.layout.drawer.tabs.layers.opacity.enabled', false)
    if (!licensed) {
      icon = <IconOpacity htmlColor={ICON_COLOR_DISABLED} />
      markup = (<div className={classes.upgradeWrapper}>{this.pure.upgradeMarkup}</div>)
      return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_OPACITY} headerIcon={icon} markup={markup} licensed={licensed} />
    }

    icon = <IconOpacity htmlColor={ICON_COLOR_ENABLED} />
    markup = (
      <div className={classes.root}>
        <Slider value={value} aria-labelledby="continuous-slider" onChange={this.pure.handleChange} />
      </div>
    )
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_OPACITY} headerIcon={icon} markup={markup} licensed={licensed} />
  }
}

LayerPanelOpacity.propTypes = {
  classes: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LayerPanelOpacity)
  )
)
